import { render, staticRenderFns } from "./section-associate.vue?vue&type=template&id=36c07248&scoped=true"
import script from "./section-associate.vue?vue&type=script&lang=js"
export * from "./section-associate.vue?vue&type=script&lang=js"
import style0 from "./section-associate.vue?vue&type=style&index=0&id=36c07248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c07248",
  null
  
)

export default component.exports